export const rudderstack = {
    name: 'RudderStack',
    key: 'rudderstack',
    assets: {
        icon: '/images/competitors/rudderstack.svg',
    },
    products: {
        cdp: {
            available: true,
            features: {
                number_of_integrations: '200+',
                realtime_streaming: true,
                built_in_analytics: false,
            },
        },
    },
    data_warehouse: {
        available: true,
        features: {
            batch_exports: true,
            warehouse_sources: true,
        },
    },
    platform: {
        analytics_integration: {
            built_in_analytics: false,
        },
        deployment: {
            open_source: true,
            self_host: true,
        },
        developer: {
            api: false,
            collaboration: false,
            mobile_sdks: false,
            native_data_sources: false,
            proxies: false,
            sdks: false,
            server_side_sdks: false,
            sql: false,
        },
        tools: {
            cms: '',
            notebooks: false,
            project_management_tools: '',
        },
        integrations: {
            azure_blob: false,
            bigquery: false,
            ci_cd_integrations: false,
            community_integrations: false,
            csv_exports: false,
            customer_io: false,
            datadog: false,

            email_reports: false,
            exports: true,
            gcs: false,
            google_ads: false,
            hubspot: false,
            imports: true,
            intercom: false,
            microsoft_teams: false,
            redshift: false,
            s3: false,
            segment: false,
            sentry: false,
            slack: false,
            snowflake: false,
            stripe: false,
            warehouse_import: false,
            wordpress: false,
            zapier: false,
            zendesk: false,
        },
        pricing: {
            free_tier: true,
            transparent_pricing: false,
            usage_based_pricing: true,
        },
        security: {
            bot_blocking: false,
            cookieless_tracking: false,
            data_anonymization: false,
            data_retention: false,
            gdpr_ready: false,
            hipaa_ready: false,
            history_audit_logs: false,
            reverse_proxy: false,
            saml_sso: false,
            soc2_certified: false,
            two_factor_auth: false,
            user_privacy_options: false,
        },
    },
    pricing: {
        model: 'Usage-based',
    },
}
